import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';
import { useAdminWalletSettingsQuery } from './useAdminWalletSettingsQuery';

export const useAdminWalletSettingsUpdateQuery = (callBack?: () => void) => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	const listQuery = useAdminWalletSettingsQuery();

	return useMutationHook(
		[endPointUrls.ADMIN_WALLET_SETTINGS_UPDATE],
		(data: any) => api.patch(endPointUrls.ADMIN_WALLET_SETTINGS_UPDATE, data),
		{
			onSuccess: (res) => {
				const response = res as AxiosResponse;

				if (response?.status === 200) {
					queryClient.invalidateQueries([endPointUrls.ADMIN_WALLET_SETTINGS_UPDATE]);
					toastHandler('success', response?.data.message);
					dispatch(setApiCatcherFormErrors([]));
					listQuery.refetch();
					callBack?.();
				}
			},
		}
	) as UseMutationResult;
};
